import React from 'react';
import './StatsBar.css';

const stats = [
  {
    value: '500+',
    label: 'Machines Installed',
  },
  {
    value: '1K+',
    label: 'Happy Clients',
  },
  {
    value: '10+',
    label: 'Years of Expertise',
  },
];

const StatsBar = () => {
  return (
    <section className="stats-section">
      <div className="stats-container">
        {stats.map((stat, index) => (
          <React.Fragment key={stat.label}>
            <div className="stat-item">
              <span className="stat-number">{stat.value}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
            {index < stats.length - 1 && <div className="stat-divider" />}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default StatsBar;
